export function pathWithQuery(url: string): string | null {
  if (!URL.canParse(url)) {
    return null;
  }

  const urlStructure = new URL(url);
  return urlStructure.pathname + urlStructure.search;
}